import { useAppSelector } from '../../lib/hooks';
import { removeDocumentStructure } from '../../lib/state/slices/ProjectStateSlice';
import { Dialog, Portal, Stack, Text } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { toaster } from '../ui/toaster';
import { useNavigate, useLocation } from 'react-router-dom';
import StyledButton from '../ui/styledButton';

export default function DeleteFolderDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  folderId: string;
}) {
  const dispatch = useDispatch();
  const folders = useAppSelector((state) => state.viewReducer.documents.structure.FOLDER);

  const navigate = useNavigate();
  const location = useLocation();

  const folderValues = Object.values(folders);

  return (
    <Dialog.Root open={props.isOpen} onOpenChange={props.onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content backgroundColor="midCardBG">
            <Dialog.Header>
              <Dialog.Title color="primaryText">Delete Folder</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Stack gap={4}>
                <Text color="secondaryText">Are you sure you want to delete this folder?</Text>
              </Stack>
            </Dialog.Body>
            <Dialog.Footer>
              <StyledButton variant="outline" text="Cancel" onClick={props.onClose} />
              <StyledButton
                variant="danger"
                text="Delete"
                onClick={() => {
                  if (folderValues.length === 1) {
                    toaster.create({
                      type: 'error',
                      title: 'Error',
                      description: 'You must have at least one folder',
                      status: 'error',
                    });
                  } else {
                    dispatch(removeDocumentStructure({ type: 'FOLDER', key: props.folderId }));
                    if (location.pathname === `/folders/${props.folderId}`)
                      navigate(`/folders/${folders[0].id}`);
                  }
                  props.onClose();
                }}
              />
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
